"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("./styles.scss");
const Tabs = (props) => {
    const { tabs, selectedTabId, selectTab, className } = props;
    const selectTabHandler = (id) => () => {
        selectTab(id);
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("c-tabs", className) }, tabs.map(({ label, id }) => (react_1.default.createElement("div", { key: id, className: (0, classnames_1.default)("c-tabs__tab", { "c-tabs__tab--selected": selectedTabId === id }), onClick: selectTabHandler(id) }, label)))));
};
exports.Tabs = Tabs;
